import type { Project, User } from '@altyor-kronos/shared-types';
import { isAssignedToMe } from '../projects/validators';

export interface TrackerProject {
  id: string;
  data: Project;
  /** True when the user already belongs to the project (or holds an auto-assigned role). */
  assigned: boolean;
}

/**
 * Flag each project with the viewer's assignment and sort assigned
 * projects first. Within each group the incoming order is preserved
 * (the Firestore query already orders by name).
 *
 * The tracker's project picker intentionally lists EVERY active
 * project — logging time on a non-member project auto-adds the user
 * to the team server-side (see functions/on-time-entry-created.ts).
 * The assigned-first sort keeps the contiguous grouping MUI's
 * Autocomplete `groupBy` requires ("My projects" / "Other projects").
 */
export function markAndSortTrackerProjects(
  projects: Array<{ id: string; data: Project }>,
  user: User | null,
): TrackerProject[] {
  if (!user) return [];
  const flagged = projects.map((p) => ({
    ...p,
    assigned: isAssignedToMe(user, { ...p.data, id: p.id }),
  }));
  return [...flagged.filter((p) => p.assigned), ...flagged.filter((p) => !p.assigned)];
}
